import { render, staticRenderFns } from "./AppProfile.vue?vue&type=template&id=2fbf3532&scoped=true&"
import script from "./AppProfile.vue?vue&type=script&lang=js&"
export * from "./AppProfile.vue?vue&type=script&lang=js&"
import style0 from "./AppProfile.vue?vue&type=style&index=0&id=2fbf3532&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbf3532",
  null
  
)

export default component.exports